import { slice } from '../slices';

const nameSpace = slice.name;

export const notifications = (state) => state[nameSpace].notifications;

export default {};
